<template>
  <b-modal id="user-personal-topic-modal"
           size="lg"
           class="modal-fullscreen1"
           scrollable
           no-close-on-backdrop
           hide-footer
           hide-header>
    <confirm-personal-topic @saved="closeModal()"/>
  </b-modal>
</template>

<script>
  import ConfirmPersonalTopic from './ConfirmPersonalTopic'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      ConfirmPersonalTopic,
      SweetModal
    },
    methods: {
      openModal () {
        this.$bvModal.show('user-personal-topic-modal')
      },
      closeModal () {
        this.$bvModal.hide('user-personal-topic-modal')
      }
    }
  }
</script>

<style scoped>
  .modal-fullscreen1 .modal {
    padding: 0 !important;
  }
  .modal-fullscreen1 .modal-dialog {
    max-width: 100%;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen1 .modal-content {
    border: 0;
    border-radius: 0;
    min-height: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/privacy/ConfirmPersonalTopicModal.vue